<div class="" style="display: flex; flex-direction: column; gap: 8px;" @fadeInOut>
  @for (messageBar of messageBars(); track messageBar.id) {
    <div class="msg-bar-wrapper">
      <soft-message-bar [config]="messageBar" (dismiss)="onDismiss($event)"></soft-message-bar>
    </div>
  }
</div>
